module.exports = __webpack_public_path__ + "assets/img/00019.ad421869.png";